import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import openChatIcon from '../../../../images/open-chat.svg';
import renderIfChatAvailable from '../renderIfChatAvailable';
import { getBrandId, getCurrentUserId, getShop } from '../../auth/selectors';
import { containerApp } from '../../../main';

const ChatButton = ({ setIsChatOpen, chatUnreadMessagesCount, shopId, brandId, userId }) => {
  const handleChatOpen = () => {
    setIsChatOpen(true);
  };

  return (
    <button
      data-automation-id="chat-button"
      className="c-btn c-btn--register-opener c-btn--chat"
      onClick={handleChatOpen}
    >
      <img src={openChatIcon} alt="Open chat" />
      {!!chatUnreadMessagesCount && <div className="c-btn--notification">{chatUnreadMessagesCount}</div>}
    </button>
  );
};

ChatButton.propTypes = {
  setIsChatOpen: PropTypes.func.isRequired,
  chatUnreadMessagesCount: PropTypes.number.isRequired,
  shopId: PropTypes.string.isRequired,
  brandId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

export default compose(
    renderIfChatAvailable,
    containerApp.hideForContainerApp,
    connect(state => ({
      shopId: getShop(state),
      brandId: getBrandId(state),
      userId: getCurrentUserId(state),
    })),
)(ChatButton);
